import { Button, styled, useTheme } from '@mui/material';

const ButtonSubmit = styled(Button)(() => {
  const theme = useTheme();

  return {
    width: '100%',
    height: '40px',
    borderRadius: '5px',
    padding: '12px 10px',
    marginBottom: '30px',
    textTransform: 'none',
    border: `1px solid ${theme.palette.primary.main}`,
    color: 'white',
    backgroundColor: `${theme.palette.primary.main}`,

    '&:hover': {
      backgroundColor: '#1C9D57',
      border: `1px solid ${theme.palette.primary.main}`,
      boxShadow: 'none',
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: '#1C9D57',
      border: `1px solid ${theme.palette.primary.main}`,
    },
    '&:focus': {
      boxShadow: '0 0 0 0.1rem rgba(70, 255, 70, 0.15)',
      border: `1px solid ${theme.palette.primary.main}`,
    },
  };
});

export default ButtonSubmit;
